import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { AppConfigService } from '../../services/app-config.service';

/**
 * Ajoute systématiquement les cookies d'authentification (`ACCESS_TOKEN` / `REFRESH_TOKEN`) aux
 * requêtes envoyées vers le backend LIDIA, en positionnant `withCredentials: true`.
 * Indispensable car le front et le back ne partagent pas la même origine (cf. `urlServeur` dans
 * `config.json`), les cookies ne sont donc pas transmis par défaut par le navigateur.
 */
@Injectable()
export class CredentialsInterceptor implements HttpInterceptor {

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const urlServeur = AppConfigService.settings ? AppConfigService.settings.urlServeur : null;

    if (urlServeur && req.url.indexOf(urlServeur) === 0) {
      req = req.clone({ withCredentials: true });
    }

    return next.handle(req);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/interceptors/credentials.interceptor.ts